import { Button, FileUpload, FormField } from "@wix/design-system";
import React, { useContext } from "react";
import {
  EditorContext,
  PluginsEventsContext,
  RicosContext,
  UploadContext,
  useDevService
} from "./../../ricos-context/index.js";
import { useWixInstanceService } from "./../../_shared/request-service-provider/wix-instance-context.js";
import { useEditorProps } from "./../../_shared/some-editor-props-context.js";
import { MEDIA_POPOVERS_BUTTONS_NAMES_BI } from "./../../wix-rich-content-common/index.js";
import { handleAudioUpload } from "./../handle-audio-upload.js";
import { audioFileTypes } from "../consts.js";
import { UPLOAD_TAB_UPLOAD_BUTTON } from "../data-hooks.js";
import { AUDIO_TYPE } from "../types.js";
const AudioUpload = ({ nodeId, closeModal, logBi }) => {
  const { t } = useContext(RicosContext);
  const { getPublicCommands } = useContext(EditorContext);
  const { uploadService } = useContext(UploadContext);
  const pluginsEvents = useContext(PluginsEventsContext);
  const wixInstance = useWixInstanceService();
  const editorProps = useEditorProps();
  const { metaSiteId } = wixInstance();
  const devService = useDevService();
  const publicCommands = getPublicCommands();
  const handleUploadClick = async () => {
    pluginsEvents.publishPluginPopoverClick?.({
      pluginId: AUDIO_TYPE,
      buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.upload
    });
    logBi({ dataHook: UPLOAD_TAB_UPLOAD_BUTTON });
    handleAudioUpload({
      services: {
        uploadService,
        devService,
        wixInstance,
        editorProps
      },
      publicCommands,
      nodeId,
      type: "audio"
    });
    closeModal();
  };
  return /* @__PURE__ */ React.createElement(FormField, { label: t("AudioModal_Upload_Title"), maxLines: 2 }, metaSiteId || devService().handleFileSelection || devService().handleFileUpload || editorProps.pickMedia?.pickAudio ? /* @__PURE__ */ React.createElement(FileUpload, { onChange: () => {
  }, accept: audioFileTypes }, () => /* @__PURE__ */ React.createElement(
    Button,
    {
      dataHook: UPLOAD_TAB_UPLOAD_BUTTON,
      onClick: handleUploadClick,
      fullWidth: true,
      size: "small"
    },
    t("AudioModal_Upload_ButtonText")
  )) : null);
};
export {
  AudioUpload
};
//# sourceMappingURL=audio-upload.js.map
